//This file is used to get CodeKit to load the latest version of Swiper JS files and the Swiper modules that are used in the theme.
//It is necessary to first run `npm install swiper` in the theme directory.  Then have CodeKit compile this file with UMD Bundle format.
//See also the swiper.scss file that has directives for CodeKit to bundle the necessary CSS modules.

/* eslint-disable no-unused-vars */
// core version + navigation, pagination modules:
import Swiper from 'swiper';
/* rollup-disable-treeshake */
import { Navigation, Pagination } from 'swiper/modules';  //If you add any modules, also add them to the scss file.
// eslint-enable no-unused-vars

window.Swiper = Swiper;
export {Pagination, Navigation};
// window._swiper_pagination = Pagination;
// window._swiper_navigation = Navigation;
// var qty = 0;
// export {qty};